import React, { Component } from "react"
import { Button, Row, Modal, Spin, message } from 'antd'
import { Route } from "react-router-dom"
import HaplotypeCard from "app/components/normal/HaplotypeCard"
import BaseCollapse from "app/components/normal/BaseCollapse"
import catalogIcon from 'app/styles/images/sp/catalog.svg'
import downloadIcon from "app/styles/images/sp/download.svg"
import Store from "app/stores/arrayPgt/haplotypeReport"
import SampleInfo from './containers/SampleInfo'
import SampleResult from "./containers/SampleResult"
import ReportDetail from './containers/ReportDetail'
import './index.scss'
import {observer, inject } from "mobx-react"

@inject('entrance', 'auth') @observer
class HaplotypeReport extends Component {
  constructor(props) {
    super(props)
    this.store = Store.fromJS()
    this.state = {
      exportModalShowed: false
    }
  }

  componentDidMount() {
    let { getDetailData } = this.store

    const { match: { params: { id } }, location } = this.props
    getDetailData(id)
      .then(res => {
        const pathArr = location.pathname.split('/')
        const fileId = pathArr.slice(-1)[0]
        if (pathArr.slice(-2)[0] === 'detail') {
          this.initDetailData(id, fileId)
        }
      })
  }

  initDetailData = (reportId, fileId) => {
    const { getDetailData, getPgtaDetailData, detailData: { inforStats } } = this.store
    const index = inforStats && inforStats.findIndex(info => info.fileId === fileId)
    this.setState({
      dataIndex: index
    })

    getDetailData(reportId)
      .then(res => {
        getPgtaDetailData(reportId, fileId)
      })
  }

  onOpenCopyDetail = (fileId) => {
    const { getPgtaDetailData, detailData: { inforStats } } = this.store
    let { history, match, match: { params: { id } } } = this.props

    const index = inforStats && inforStats.findIndex(info => info.fileId === fileId)

    this.setState({
      dataIndex: index
    })

    getPgtaDetailData(id, fileId)
    history.push(`${match.url}/detail/${fileId}`)
  }

  dataSwitch = (index, record) => {
    let { match, history, match: { params: { id } } } = this.props
    const { getPgtaDetailData } = this.store

    this.setState({
      dataIndex: index,
    })

    history.replace(`${match.url}/detail/${record.fileId}`)
    getPgtaDetailData(id, record.fileId)
  }

  downloadReport = () => {
    let { match: { params: { id } } } = this.props
    const { downloadReport } = this.store
    downloadReport(id)
      .then(res => {
        const exportDataUrl = res.url

        this.setState({
          exportModalShowed: false,
        })

        if (document.getElementById("export-a-tag")) document.getElementById("export-a-tag").outerHTML = ""
        let a = document.createElement("iframe")
        a.setAttribute("src", exportDataUrl)
        a.setAttribute("id", "export-a-tag")
        a.setAttribute("style", "display:none;")
        // 防止反复添加
        if (!document.getElementById("export-a-tag")) document.body.appendChild(a)
      }, err => {
        message.error("导出失败，请您重试！")
        this.setState({
          exportModalShowed: false,
        })
      })
  }

  render() {
    const { pgtaDetailData, detailData } = this.store
    let { match, history, match: { params: { id: reportId } } ,entrance} = this.props
    const { dataIndex } = this.state
    let templates = entrance.templates
    return (
      <div className="haplotype-wrapper">
        <HaplotypeCard title='样本信息'>
          <SampleInfo
            store={this.store}
          />
        </HaplotypeCard>
        <HaplotypeCard title='样本结果'>
          <SampleResult
            store={this.store}
            onOpenCopyDetail={this.onOpenCopyDetail}
          />
        </HaplotypeCard>
        <HaplotypeCard title='家系结果'>
          {detailData.results && detailData.results.map((dir, index) => {
            return (
              <div
                key={index}
                className="view-report-item"
              >
                <img className="dir-img" src={catalogIcon} alt='' />
                <span>{dir.name}</span>
                <Button
                  type='primary'
                  size='small'
                  style={{ marginLeft: 16 }}
                  onClick={() => history.push(`/jab/array-pgt/${reportId}/result/${dir.resultType}/${dir.value}`)}
                >
                  查看
                </Button>
              </div>
            )
          })}
        </HaplotypeCard>
        <BaseCollapse title='运行信息'>
          <Row type="flex" justify="start">
            <label className="run-label">taskId：</label>
            <p>{detailData.taskId}</p>
          </Row>
          <Row type="flex" justify="start">
            <label className="run-label">reportId：</label>
            <p>{detailData.reportId}</p>
          </Row>
          <Row type="flex" justify="start">
            <label className="run-label">runtime message：</label>
            <pre>{detailData.runtime ? detailData.runtime.message : ''}</pre>
          </Row>
        </BaseCollapse>
        <a
          title="下载报告"
          className="haplotype-download"
          onClick={this.downloadReport}
        >
          <img src={downloadIcon} alt="下载" />
        </a>
        {/* 拷贝数报告详情modal */}
        <Route
          path={`${match.url}/detail/:fileId`}
          render={() => {
            return (
              <Modal
                title="拷贝数报告详情"
                footer={0}
                width={1172}
                maskClosable={false}
                visible={true}
                onCancel={history.goBack}
                className="detail-modal"
              >
                <ReportDetail
                  index={dataIndex}
                  data={detailData}
                  pgtaDetailData={pgtaDetailData}
                  reportList={detailData.inforStats}
                  dataSwitch={this.dataSwitch}
                  store={this.store}
                  templates={templates}
                  groupId={detailData.groupId}

                />
                 
              </Modal>
            )
          }}
        />
        <Modal
          className="statistics-export-modal"
          width={230}
          visible={this.state.exportModalShowed}
          footer={null}
        >
          <div className="export-loading"><Spin size="large" /></div>
          <div className="export-tips">正在导出中，请稍等。。。</div>
        </Modal>
      </div>
    )
  }
}

export default HaplotypeReport


// WEBPACK FOOTER //
// ./src/app/pages/arrayPgt/haplotypeReport/index.js